import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduledJobModalComponent } from './scheduled-job-modal/scheduled-job-modal.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedComponentsModule } from 'src/app/shared/shared-components/shared-components.module';
import { SchedulerComponentsModule } from '../components/scheduler-components.module';

@NgModule({
  declarations: [
    ScheduledJobModalComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    SharedComponentsModule,
    SchedulerComponentsModule,
  ],
  exports: [
    ScheduledJobModalComponent,
  ]
})
export class SharedSchedulerComponentsModule { }
